export function GetDisplayQuestions(questions, review) {
    var display_questions = [];
    var st_questions = [];
  
    questions.forEach((question) => {
      if (question.parent_question == null) {
        display_questions.push(question.id);
        if (question.type == "S" || question.type == "M") {
          st_questions.push(question);
        }
      }
    });
    while (st_questions.length != 0) {
      var current_question = st_questions.pop();
  
      if (review[current_question.id] != null) {
        if (current_question.type == "M") {
          for (const question of questions) {
            if (
              review[current_question.id].includes(question.option_id?.toString())
            ) {
              display_questions.push(question.id);
            }
            if (
              !question.option_id &&
              question.parent_question == current_question.id
            ) {
              if (review[current_question.id].length) {
                display_questions.push(question.id);
                if (question.type == "S" || question.type == "M") {
                  st_questions.push(question);
                }
              }
            }
          }
        }
        if (current_question.type == "S") {
          for (const question of questions) {
            if (question.option_id == review[current_question.id]) {
              display_questions.push(question.id);
              if (question.type == "S" || question.type == "M") {
                st_questions.push(question);
              }
            }
            if (
              !question.option_id &&
              question.parent_question == current_question.id
            ) {
              if (review[current_question.id]) {
                display_questions.push(question.id);
                if (question.type == "S" || question.type == "M") {
                  st_questions.push(question);
                }
              }
            }
          }
        }
      }
    }
    return display_questions;
  }
  